import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Loading from '../common/Loading';
import PipButton from './buttons/PipButton';

import { getLiveChannelType } from '../../../../src/common/utils/liveUtil';
import * as PLAYER from '../../../common/constants/player';

export default function PlayerWrapper(props) {
  const [isBottom, setIsBottom] = useState(false);
  const [isClose, setIsClose] = useState(false);
  const [isShowPipButton, setIsShowPipButton] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const [isDevelop, setIsDevelop] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    // 클라이언트 사이드에서 개발 환경 감지
    // sbs-player는 development 속성이 한 번이라도 세팅되면 내부 호스트 자동감지를 끄기 때문에,
    // 마운트 후 확정된 값으로 엘리먼트를 생성해야 dev(apis.developers) API를 탄다.
    if (typeof window !== 'undefined') {
      setIsDevelop(window.location.hostname !== 'www.sbs.co.kr');
      setIsMounted(true);
    }
  }, []);

  useEffect(() => {
    const handleScrollEvent = () => {
      try {
        const windowViewTop = window.scrollY || window.pageYOffset;
        const playerElement = document.getElementById(
          PLAYER.ID_PLAYER_CONTAINER
        );
        const playerOffsetTop =
          playerElement.offsetTop || playerElement.getBoundingClientRect().top;
        const playerOffsetBottom = playerOffsetTop + playerElement.offsetHeight;

        if (playerOffsetBottom >= windowViewTop) {
          setIsBottom(false);
          setIsClose(false);
        } else {
          if (!isClose) setIsBottom(true);
        }
      } catch (e) {
        console.error(e);
      }
    };

    setIsRender(false);

    const initPlayer = (data) => {
      if (
        SBS_ONAIR_PLAYER_GLOBAL &&
        SBS_ONAIR_PLAYER_GLOBAL.MODEL.VIDEOJS.PLAYER === Object &&
        Object.keys(SBS_ONAIR_PLAYER_GLOBAL.MODEL.VIDEOJS.PLAYER).length > 0
      ) {
        SBS_ONAIR_PLAYER_GLOBAL.MODEL.VIDEOJS.PLAYER.dispose();
      }

      let player;
      if (getLiveChannelType(props.data.channelid) === 'radio') {
        player = new SBSOnAirRadioPlayerMainContainer(PLAYER.ID_PLAYER_WRAPPER);
        player.callback.initialized = function () {
          player.render();
          //setIsRender(true);
        };
        player.callback.rendered = function () {
          window.document.addEventListener('scroll', handleScrollEvent);
        };
        player.initialize(data);
      } else {
        //player = new SBSOnAirPlayerMainContainer(PLAYER.ID_PLAYER_WRAPPER);
      }
    };

    const playerContainer = document.getElementById(PLAYER.ID_PLAYER_CONTAINER);
    playerContainer.addEventListener(
      'mouseenter',
      function (event) {
        setIsShowPipButton(true);
      },
      false
    );
    playerContainer.addEventListener(
      'mouseleave',
      function (event) {
        setIsShowPipButton(false);
      },
      false
    );

    initPlayer(options);
  }, []); // 라이브 엔드는 ~~SPA~~ 새로운 페이지에서 다시 시작하게 변경(미드롤, 라디오 등 이슈많음)

  const options = {
    channel: props.data.channelid,
    channel_type: String(props.data.type).toLocaleLowerCase(),
    mode: {
      popup: false,
    },
  };

  const handleClickPipClose = (e) => {
    setIsClose(true);
    setIsBottom(false);
  };

  return (
    <div className="live_player_box">
      <div
        id={PLAYER.ID_PLAYER_CONTAINER}
        className="player_box_video"
        style={{
          backgroundColor: '#1a1a1a',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {!props.data && <Loading />}
        {!isRender && (
          <div
            className={`player_video_w ${
              !isClose && isBottom ? 'live_pip_layer' : ''
            }`}
            style={{
              width: !isClose && isBottom ? '400px' : '100%',
              height: !isClose && isBottom ? '225px' : '100%',
            }}
          >
            <div
              id={PLAYER.ID_PLAYER_WRAPPER}
              style={{ width: '100%', height: '100%' }}
            >
              {isMounted && (
                <sbs-player
                  target="live"
                  media={props.data.channelid}
                  w="100%"
                  h="100%"
                  development={isDevelop ? 'true' : 'false'}
                ></sbs-player>
              )}
            </div>
            <PipButton
              view={!isClose && isBottom && isShowPipButton}
              onClick={handleClickPipClose.bind(this)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
